module.exports = __webpack_public_path__ + "fonts/Ubuntu-MediumItalic.c1fa06a.woff";